import { render, staticRenderFns } from "./realTimeView.vue?vue&type=template&id=2031ba4e&scoped=true"
import script from "./realTimeView.vue?vue&type=script&lang=js"
export * from "./realTimeView.vue?vue&type=script&lang=js"
import style0 from "./realTimeView.vue?vue&type=style&index=0&id=2031ba4e&prod&lang=less&scoped=true"
import style1 from "./realTimeView.vue?vue&type=style&index=1&id=2031ba4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2031ba4e",
  null
  
)

export default component.exports